
















/**
 * Le nom "Link" est réservé en html, on utilise donc le nom en français pour ce composant
 */
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'Lien',
    props: {
        isButton: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
        href: {
            type: String,
            default: undefined
        },
        isTextLink: {
            type: Boolean,
            default: true
        },
        noDecoration: {
            type: Boolean,
            default: false
        },
        isLinkArrow: {
            type: Boolean,
            default: false
        },
        isLinkArrowBack: {
            type: Boolean,
            default: false
        },
        isMini: {
            type: Boolean,
            default: false
        },
        isLarge: {
            type: Boolean,
            default: false
        },
        openNewTab: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes(): Record<string, boolean> {
            return {
                "ob1-link": this.isTextLink,
                "no-decoration": this.noDecoration,
                "ob1-link-arrow": this.isLinkArrow,
                "ob1-link-arrow back": this.isLinkArrowBack,
                "ob1-link-small": this.isMini,
                "ob1-link-large": this.isLarge
            };
        }
    },
    methods: {
        clickHandler(): void {
            this.$emit("click");
        }
    }
});
